/*
 * [ECOMHARD] Cart cross-sells stabilizer
 * - Keeps the Search & Discovery cross-sell Swiper updated after AJAX cart renders.
 * - Recalculates the slider when the quick cart opens.
 * - Cart page desktop: 2 products + a peek of the next product.
 * - Quick cart/mobile: preserves the theme's 1.15 products per view behavior.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-cross-sells]';
  var SLIDER_SELECTOR = '.cross-sells__items.swiper[data-cross-sells-slider="true"]';
  var MAX_RETRIES = 30;
  var RETRY_DELAY = 60;
  var resizeTimer = null;

  function isCartPageCrossSell(root) {
    return Boolean(
      root.closest('[data-section-type="cart"]') &&
      !root.closest('[data-section-type="quick-cart"]')
    );
  }

  function desiredSlidesPerView(root) {
    if (isCartPageCrossSell(root) && window.matchMedia('(min-width: 720px)').matches) {
      return 2.15;
    }

    return 1.15;
  }

  function refreshSwiper(root, attempt) {
    attempt = attempt || 0;

    if (!root || !document.documentElement.contains(root)) return;

    var slider = root.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    var slides = slider.querySelectorAll('.cross-sells__item.swiper-slide');

    // Search & Discovery inserts the recommendation cards asynchronously.
    if (!slides.length) {
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          refreshSwiper(root, attempt + 1);
        }, RETRY_DELAY);
      }
      return;
    }

    // Swiper is imported asynchronously by the theme. Wait until its instance exists.
    var swiper = slider.swiper;
    if (!swiper || swiper.destroyed) {
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          refreshSwiper(root, attempt + 1);
        }, RETRY_DELAY);
      }
      return;
    }

    var slidesPerView = desiredSlidesPerView(root);

    swiper.params.slidesPerView = slidesPerView;
    swiper.params.spaceBetween = 8;

    // Keep our values when Swiper internally re-reads its original parameters.
    if (swiper.originalParams) {
      swiper.originalParams.slidesPerView = slidesPerView;
      swiper.originalParams.spaceBetween = 8;
    }

    try {
      if (typeof swiper.updateSize === 'function') swiper.updateSize();
      if (typeof swiper.updateSlides === 'function') swiper.updateSlides();
      if (typeof swiper.updateProgress === 'function') swiper.updateProgress();
      if (typeof swiper.updateSlidesClasses === 'function') swiper.updateSlidesClasses();
      if (typeof swiper.update === 'function') swiper.update();
      if (swiper.navigation && typeof swiper.navigation.update === 'function') {
        swiper.navigation.update();
      }
    } catch (error) {
      // A cart refresh can destroy the previous instance between frames.
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          refreshSwiper(root, attempt + 1);
        }, RETRY_DELAY);
      }
    }
  }

  function scheduleRefresh(root) {
    if (!root || !document.documentElement.contains(root)) return;

    [0, 80, 180, 350].forEach(function (delay) {
      window.setTimeout(function () {
        refreshSwiper(root, 0);
      }, delay);
    });
  }

  function refreshAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches(ROOT_SELECTOR)) {
      scheduleRefresh(context);
    }

    context.querySelectorAll(ROOT_SELECTOR).forEach(scheduleRefresh);
  }

  function init() {
    refreshAll(document);

    // Main cart and quick-cart replace their HTML after quantity/add/remove operations.
    var domObserver = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          shouldRefresh = true;
          break;
        }
      }

      if (shouldRefresh) refreshAll(document);
    });

    if (document.body) {
      domObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // The drawer is off-canvas during its first Swiper calculation. Recalculate
    // after the active class is applied so its controls never disappear.
    document.querySelectorAll('.quick-cart__wrapper').forEach(function (wrapper) {
      var quickCartObserver = new MutationObserver(function () {
        if (wrapper.classList.contains('active')) {
          var quickCart = wrapper.closest('[data-section-type="quick-cart"]');
          refreshAll(quickCart || document);
        }
      });

      quickCartObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        refreshAll(document);
      }, 120);
    });

    window.addEventListener('pageshow', function () {
      refreshAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
